import useSessionStorage from '../storage/useSessionStorage';
import { clickupAPI } from '../../utils/api/clickup';
import { useRef, useCallback, useEffect, useState } from "react";

const PAGE_SIZE = 100;
const PAGE_BATCH = 5;

const useFetchAdditionalTasks = (listId, pollTrigger, hasCachedData, company) => {
  const [tasks, setTasks] = useState([]);
  const [loadingFull, setLoadingFull] = useState(false);
  const [isFetching, setIsFetching] = useState(false);
  const fullBackfillPromise = useRef(null);

  useEffect(() => {
    if (!hasCachedData) fetchFirstPage();
  }, [listId]);

  useEffect(() => {
    if (pollTrigger == 0 || pollTrigger == null) return;
    fetchFirstPage();
  }, [pollTrigger]);

  const fetchFirstPage = useCallback(async () => {
    const action = company ? "getCustomerTasks" : "getTasks";
    const page0 = await clickupAPI({ action, listId, page: 0, company });
    setTasks(page0);

    fullBackfillPromise.current = fetchAdditionalData();
  }, [listId, company]);


  const fetchAdditionalData = async () => {
    try {
      if (isFetching) return;
      setIsFetching(true);
      setLoadingFull(true);

      const action = company ? "getCustomerTasks" : "getTasks";
      const results = [];
      let page = 0;
      let isKeepGoing = true;

      while (isKeepGoing) {
        const promises = [];

        for (let i = 0; i < PAGE_BATCH; i++) {
          promises.push(clickupAPI({ action, listId, page: page + i, company }));
        }

        const batchResults = await Promise.all(promises);

        for (const tasks of batchResults) {
          if (!tasks || tasks.length === 0) {
            isKeepGoing = false;
            break;
          }

          results.push(...tasks);

          if (tasks.length < PAGE_SIZE) {
            isKeepGoing = false;
            break;
          }
        }

        page += PAGE_BATCH;
      }

      setLoadingFull(false);
      setTasks(results);
      setIsFetching(false);
    } catch (error) {
        console.error("Error fetching additional tasks:", error);
    }
  };

  return { tasks, loadingFull  };
};

export default useFetchAdditionalTasks;